import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import * as S from './styled';
const StyledButton = styled.div`
  ${S.BaseButtonStyling};
  ${props => S[props.size]};
  ${props => S[props.variant]};
`;

const BaseButton = ({
  type,
  children,
  ...remainingProps
}) => {
  const newChildren = React.Children.map(children, child => {
    if (React.Children.count(children) === 1 || /*#__PURE__*/React.isValidElement(child) || child === false || child === null) {
      return child;
    }

    return /*#__PURE__*/React.createElement("span", null, child);
  });
  return /*#__PURE__*/React.createElement(StyledButton, {
    type: type === 'link' ? null : type,
    as: type === 'link' ? 'a' : 'button',
    ...remainingProps
  }, newChildren);
};

BaseButton.defaultProps = {
  variant: 'red',
  size: 'large',
  fullWidth: false,
  type: 'button',
  children: null,
  onClick: null
};
BaseButton.propTypes = {
  variant: PropTypes.oneOf(['red', 'white', 'outline', 'underline', 'text', 'ghost', 'disabled', 'menu']),
  size: PropTypes.oneOf(['small', 'large']),
  fullWidth: PropTypes.bool,
  type: PropTypes.oneOf(['link', 'button', 'submit']),
  children: PropTypes.node,
  onClick: PropTypes.func
};
export default BaseButton;